import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import firebase from 'firebase';
import React from 'react';

import songBuilderApp from './reducers/index';

import {
  firestoreSonglistFetching,
  receivedfirestoreSonglist,
  FIRESTORE_SONGLIST_RECEIVED,
  receivedUpdatedSongFromFirestore,
  FIRESTORE_SONG_RECEIVED,
  FIRESTORE_SONGLIST_FETCHING,
} from './actions/firestore';

const createStoreAndDb = () => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  // const createSongBuilderStore = () => {
  // Initialize Firebase
  const config = {
    apiKey: 'AIzaSyBJ4KN2EgVXgtARZ4M3zb2Z3PHWdFQ_6jY',
    authDomain: 'songbuilder-21ecb.firebaseapp.com',
    databaseURL: 'https://songbuilder-21ecb.firebaseio.com',
    projectId: 'songbuilder-21ecb',
    storageBucket: 'songbuilder-21ecb.appspot.com',
    messagingSenderId: '316237487135',
  };
  firebase.initializeApp(config);

  const db = firebase.firestore();
  db.settings({
    timestampsInSnapshots: true,
  });

  // Enable off-line access
  db
    .enablePersistence()
    .then(() => {
      // Initialize Cloud Firestore through firebase
      // var db = firebase.firestore();
    })
    .catch((err) => {
      if (err.code === 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled
        // in one tab at a a time.
        // ...
        console.warning('Multiple tabs open, persistence can only be enabled in one tab at a a time.');
      } else if (err.code === 'unimplemented') {
        // The current browser does not support all of the
        // features required to enable persistence
        // ...
        console.warning('The current browser does not support all of the features required to enable persistence');
      }
    });

  let pushChangesTimeout;
  const myFirestoreMiddleware = _store => next => (action) => {
    console.group(`Firestore Middleware ${action.type}`);
    if (action._syncTofirebase === false) {
      console.info('Ignoring action', action);
      console.groupEnd(`Firestore Middleware ${action.type}`);
      return next(action);
    }
    switch (action.type) {
    case FIRESTORE_SONGLIST_FETCHING:
    case FIRESTORE_SONGLIST_RECEIVED:
    case FIRESTORE_SONG_RECEIVED:
      console.info('Ignoring action', action);
      console.groupEnd(`Firestore Middleware ${action.type}`);
      return next(action);
    default: {
      const prevState = _store.getState();
      console.info('dispatching', action);
      const result = next(action);
      const newState = _store.getState();
      console.log('next state', newState);

      if (newState.songlist !== prevState.songlist) {
        console.log('Songlist changed');
      }
      if (newState.song !== prevState.song) {
        if (newState.song.meta.filename) {
          // Push to firebase on a timeout
          if (pushChangesTimeout) {
            console.log('Clearning prev push timeout');
            clearTimeout(pushChangesTimeout);
            pushChangesTimeout = null;
          }
          console.log(
            'Will push to firestore in 3000ms',
            newState.song.meta.filename,
            newState.song,
          );
          pushChangesTimeout = setTimeout(() => {
            pushChangesTimeout = null;
            console.log(
              'Pushing changed song to firestore NOW...',
              newState.song.meta.filename,
              newState.song,
            );
            db
              .collection('songs')
              .doc(newState.song.meta.filename)
              .set(newState.song);
          }, 3000);
        } else {
          console.log('Song changed, but no filename, so will not push to firestore.');
        }
      }

      console.groupEnd(`Firestore Middleware ${action.type}`);
      return result;
    }
    }
  };

  const store = createStore(
    songBuilderApp,
    /* preloadedState, */
    composeEnhancers(applyMiddleware(thunk.withExtraArgument({ db }), myFirestoreMiddleware)),
  );

  // Load songlist from Firestore
  store.dispatch(firestoreSonglistFetching());

  db
    .collection('songlist')
    .doc('humphrey')
    .onSnapshot((doc) => {
      if (!doc.metadata.hasPendingWrites) {
        store.dispatch(receivedfirestoreSonglist(doc.data().filenames));
      }
    });

  db.collection('songs').onSnapshot((querySnapshot) => {
    console.group('Firestore Song onSnapshot');
    console.log('from cache?:', querySnapshot.metadata.fromCache);
    console.log('hasPendingWrites?:', querySnapshot.metadata.hasPendingWrites);
    if (!querySnapshot.metadata.hasPendingWrites) {
      const { song } = store.getState();
      // if (song) {
      let isFirst = true;
      console.log('reeived snapshot', querySnapshot);
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        console.log(song.meta.filename, isFirst);
        if (
          (song.meta.filename && data.meta.filename === song.meta.filename) ||
          (!song.meta.filename && isFirst)
        ) {
          console.log('dispatching...', data);
          store.dispatch(receivedUpdatedSongFromFirestore(data));
        }
        isFirst = false;
      });
    } else {
      console.log('Ignoring snapshot');
    }
    console.groupEnd('Firestore Song onSnapshot');
  });

  //   return {store, db};
  // };

  // export default createSongBuilderStore;
  return { store, db };
};

export default createStoreAndDb;



// WEBPACK FOOTER //
// ./src/store.js